/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { Button, Modal, ModalBody, ModalHeader } from '@msdyn365-commerce-modules/utilities';

export interface SubscriptionConfirmationModalProps {
    className: string;
    modalOpen: boolean | undefined;
    setModalOpen(newValue: boolean): void;
}

export const SubscriptionConfirmationModal = (popupProps: SubscriptionConfirmationModalProps) => {
    const { className, modalOpen, setModalOpen } = popupProps;
    const closeModal = React.useCallback(() => {
        setModalOpen(false);
    }, [setModalOpen]);

    return (
        <Modal isOpen={modalOpen} onClosed={closeModal} className={`${className}__dialog`} toggle={closeModal}>
            <ModalHeader toggle={closeModal} className={`${className}__dialog__header`}>
                <span>{'Thank you'}</span>
            </ModalHeader>
            <ModalBody className={`${className}__dialog__body`}>
                <p>{"Your notification request has been received. Please check your spam box and add Henry's to your safe list."}</p>
                <Button className={'btn'} onClick={closeModal}>
                    Close This Window
                </Button>
            </ModalBody>
        </Modal>
    );
};
